import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import numeral from 'numeral';
import * as _ from 'lodash-es';

@Component({
    selector: 'recap-loan-details',
    templateUrl: './recap-loan-details.component.html',
    styleUrls: ['./recap-loan-details.component.scss'],
    standalone: false
})
export class RecapLoanDetailsComponent implements OnInit {
    /**
     * Event emitted to tell the parent to invoke the edit action
     *
     * @type {EventEmitter<string>}
     * @memberof RecapLoanDetailsComponent
     */
    @Output() stageChange: EventEmitter<string>;
    /**
     * Incoming load details data form the parent
     *
     * @type {Object}
     * @memberof RecapLoanDetailsComponent
     */
    @Input() loanDetails: Object;
    /**
     * Flag to togle displaying the edit button
     *
     * @type {boolean}
     * @memberof RecapLoanDetailsComponent
     */
    @Input() showEditButton: boolean;
    /**
     * Formated property valuation
     *
     * @readonly
     * @type {string}
     * @memberof RecapLoanDetailsComponent
     */
    get PropertyValuation(): string {
        if (_.isEmpty(this.loanDetails)) {
            return;
        }
        return '£' + numeral(_.defaultTo(this.loanDetails['PropertyValuation'], ''))
            .format('0,0[.]00');
    }
    /**
     * Formatted loan details
     *
     * @readonly
     * @type {string}
     * @memberof RecapLoanDetailsComponent
     */
    get LoanAmount(): string {
        if (_.isEmpty(this.loanDetails)) {
            return;
        }
        return '£' + numeral(_.defaultTo(this.loanDetails['NetLoan'], ''))
            .format('0,0[.]00');
    }

    /**
     * Creates an instance of RecapLoanDetailsComponent.
     * @memberof RecapLoanDetailsComponent
     */
    constructor() {
        this.stageChange = new EventEmitter<string>();
    }
    /**
     * Initialise the component
     *
     * @memberof RecapLoanDetailsComponent
     */
    ngOnInit() {
    }
    /**
     * emit stage change when edit button clicked
     *
     * @memberof RecapLoanDetailsComponent
     */
    editButtonClicked(): void {
        this.stageChange.emit('tad_stage_loan_details');
    }

}
